/**
 * Subscriber price line — keeps the quoted subscription price in step with the
 * selected variant.
 *
 * Loaded as <script type="module">. A product page emits that tag twice (the
 * price block and the sticky add-to-cart bar), but the browser evaluates a
 * module once per URL, so this file runs once regardless. The customElements
 * guard below is belt and braces.
 *
 * This lived inline in snippets/cp-subscriber-price.liquid until 13 Sep 2026.
 * Inline was a problem because {% render %} has an isolated scope, so the
 * snippet's own "render the assets once" flag never survived to the next
 * render and every instance emitted its own copy — 25 copies, ~82KB, on a
 * 20-card collection page. Keep this in an asset file.
 */

class CpSubscriberPrice extends HTMLElement {
  connectedCallback() {
    queueMicrotask(() => this.init());
  }

  init() {
    try {
      this.prices = JSON.parse(this.dataset.variantPrices || '{}');
    } catch (e) {
      console.warn('[cp-subscriber-price] bad price data', e);
      return;
    }

    this.rate = parseFloat(this.dataset.rate || '0');
    if (!this.rate) return;

    this.amountEl = this.querySelector('[data-sub-price]');

    window.addEventListener('popstate', () => this.checkUrl());

    let lastVariant = new URLSearchParams(location.search).get('variant');
    setInterval(() => {
      const current = new URLSearchParams(location.search).get('variant');
      if (current && current !== lastVariant) {
        lastVariant = current;
        this.update(current);
      }
    }, 400);

    document.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach((input) => {
      input.addEventListener('change', () => this.update(input.value));
    });

    this.checkUrl();
  }

  checkUrl() {
    const id = new URLSearchParams(location.search).get('variant');
    if (id) this.update(id);
  }

  update(variantId) {
    const cents = this.prices[variantId];
    if (cents == null || !this.amountEl) return;
    this.amountEl.textContent = this.money(Math.round(cents * this.rate));
  }

  money(cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
    return '£' + (cents / 100).toFixed(2);
  }
}

if (!customElements.get('cp-subscriber-price')) {
  customElements.define('cp-subscriber-price', CpSubscriberPrice);
}
